import {applyMiddleware, compose, createStore} from 'redux';
import {routerMiddleware}                      from 'connected-react-router';
import {globalAppState as initialState}        from "./state";
import type {ClientConfig}                     from "@detco/check-in-terminal-js-client";
import Client                                  from "@detco/check-in-terminal-js-client";
import * as Sentry                             from "@sentry/browser";
import {createBrowserHistory}                  from 'history';
import createRootReducer                       from './reducer/reducer'
import thunk                                   from 'redux-thunk';
import packageJson                             from '../../package.json';


let rootElement          = document.getElementById('root');
let config: ClientConfig = {
    baseUrl: rootElement.dataset.api,
    version: packageJson.version
};

let apiClient     = new Client(config);
apiClient.onError = function(error) {
    Sentry.captureException(error);
};
window.setInterval(() => {
    apiClient.ping();
}, 5 * 60 * 1000);

let preloadedState = {
    ...initialState,
    app: {
        ...initialState.app,
        apiClient: apiClient
    }
};

export const history = createBrowserHistory();

//@formatter:off
function configureStore(preloadedState) {
    let devTools = a => a;

    if(
        process.env.REACT_APP_ENABLE_DEVTOOLS_EXTENSION === '1'
        && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== "undefined"
    ){
        devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
    }
    return createStore(
        createRootReducer(history),
        preloadedState,
        compose(
            applyMiddleware(
                routerMiddleware(history),
                thunk,
            ),
            devTools
        ),
    );
}
//@formatter:on

export default configureStore(preloadedState);
